import {
  ApproveContract,
  PERMIT2,
  addressEqual,
  getChainConstant,
  getUniqueTokenIds,
} from 'nftx.js';
import ApproveItem from './ApproveItem';

/**
 * Renders the necessary approve items for a list of approveContracts.
 * You get approveContracts back from nftx.js quotes (like quoting a buy/sell/swap or createVault)
 */
const renderApproveContracts = ({
  approveContracts,
  index,
  symbol,
  network,
}: {
  approveContracts: ApproveContract[];
  symbol: string;
  index: number;
  network: number;
}) => {
  return approveContracts.map(
    (
      { type, spenderAddress, tokenAddress, amount, standard, tokenIds, label },
      i
    ) => {
      let s = symbol;
      if (addressEqual(spenderAddress, getChainConstant(PERMIT2, network))) {
        s = 'Permit2';
      }

      return (
        <ApproveItem
          key={index + i}
          index={index + i}
          type={type}
          spenderAddress={spenderAddress}
          standard={standard || 'ERC20'}
          symbol={s}
          tokenAddress={tokenAddress}
          tokenIds={tokenIds ? getUniqueTokenIds(tokenIds) : undefined}
          amount={amount}
          label={label}
        />
      );
    }
  );
};

export default renderApproveContracts;
